import React from "react";
import { SkeletonContainer } from "./Components";

const Skeleton = ({ width, height, borderRadius }) => {
  return (
    <SkeletonContainer style={{ width, height, borderRadius }}></SkeletonContainer>
  );
};

export default Skeleton;
